import React from 'react';
import PropTypes from 'prop-types';
import Alert from 'react-s-alert';

import DashedButton from 'components/DashedButton';

export class CopytoClipboard extends React.PureComponent {
  get linkToPublication() {
    let host;

    switch (window.location.hostname) {
      case 'localhost':
        host = 'http://localhost:5050';
        break;
      case 'staging-admin.baza.io':
        host = 'https://staging-web.baza.io';
        break;
      case 'admin.baza.io':
        host = 'https://baza.io';
        break;
      default: return '';
    }

    if (!host) return '';
    if (this.props.isAdult) {
      return `${host}/adult/posts/${this.props.id}`;
    }

    return `${host}/posts/${this.props.id}`;
  }

  fallbackCopyTextToClipboard = () => {
    const textArea = document.createElement('textarea');
    textArea.value = this.linkToPublication;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      const messageType = successful ? 'success' : 'error';
      const message = successful
        ? 'Ссылка на публикацию скопирована'
        : 'Что-то пошло не так, попробуйте скопировать ссылку еще раз';

      Alert[messageType](message);
    } catch (err) {
      Alert.error('Произошла ошибка:', err);
    }

    document.body.removeChild(textArea);
  }

  handleCopyClick = async () => {
    if (!navigator.clipboard) {
      this.fallbackCopyTextToClipboard();
      return;
    }

    try {
      await navigator.clipboard.writeText(this.linkToPublication);

      Alert.success('Ссылка на публикацию скопирована');
    } catch (err) {
      Alert.error('Что-то пошло не так, попробуйте скопировать ссылку еще раз');
    }
  }

  render() {
    return (
      <DashedButton
        style={{ marginLeft: '16px' }}
        onClick={this.handleCopyClick}
      >
        Скопировать ссылку на публикацию
      </DashedButton>
    );
  }
}

CopytoClipboard.propTypes = {
  id: PropTypes.string.isRequired,
  isAdult: PropTypes.bool,
};

CopytoClipboard.defaultProps = {
  isAdult: false,
};

export default CopytoClipboard;
